import { render, staticRenderFns } from "./dialog-audit.vue?vue&type=template&id=50bc6a1b&"
import script from "./dialog-audit.vue?vue&type=script&lang=ts&"
export * from "./dialog-audit.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-audit.vue?vue&type=style&index=0&id=50bc6a1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports